import { createContext } from 'react';

const ThemeContext = /*#__PURE__*/createContext(undefined);

export { ThemeContext };
//# sourceMappingURL=ThemeProviderContext.mjs.map
